module.exports = __webpack_public_path__ + "static/media/BoxPlotQ8_1.11726e1c.svg";